import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import HeaderWithButton from "../../Utility/HeaderWithButton";
import { PencilSquareIcon, XMarkIcon } from "@heroicons/react/20/solid";
import { Tooltip } from "react-tooltip";
import DeleteConfirmation from "../../Utility/DeleteConfirmation";
import { Dialog } from "@headlessui/react";
import { DataContext } from "../../../helper/HelperOne";
import { Pagination } from "../../../helper/HelperTwo";
import { useToast } from "../../../context/ToastProvider";

function TypeOfWorkList() {
  const user = JSON.parse(localStorage.getItem("user"));
  // const leadTypeOfWorkPermission = user?.settings_role_based_access?.some(
  //   (access) => access.label_id == 5 && access.label_value != 0
  // );
  const { triggerToast } = useToast();
  const { searchData } = useContext(DataContext);
  const [currentPage, setCurrentPage] = useState(1);

  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [leadTypeOfWorkButton, setLeadTypeOfWorkButton] = useState("");
  const [leadTypeOfWorkData, setLeadTypeOfWorkData] = useState([]);
  const [editleadTypeOfWork, setEditleadTypeOfWork] = useState("");
  const [errors, setErrors] = useState("");
  const [paginationLeadTypeOfWorkData, setPaginationLeadTypeOfWorkData] =
    useState([]);
  const [editLeadDiscussionStationId, setEditLeadDiscussionStationId] =
    useState("");

  const [leadTypeOfWorkInputs, setLeadTypeOfWorkInputs] = useState({
    name: "",
  });

  const fetchLeadTypeOfWork = async (page = 1) => {
    const token = localStorage.getItem("token");
    if (!token) {
      triggerToast("error", "Authorization token is missing", "error");
      toast.error("Authorization token is missing");
      return;
    }

    try {
      const apiUrl = searchData
        ? `public/api/type-of-works\?page=${page}&search=${searchData}`
        : `public/api/type-of-works?page=${page}`;

      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      

      setLeadTypeOfWorkData(response.data.type_of_works);
      setPaginationLeadTypeOfWorkData(response.data.type_of_works);
    } catch (error) {
      triggerToast("error", "Error fetching lead sources", "error");
      // console.error("Error fetching lead sources:", error);
    }
  };

  useEffect(() => {
    fetchLeadTypeOfWork(currentPage);
  }, [searchData, currentPage]);

  const handleAddleadTypeOfWork = () => {
    setLeadTypeOfWorkButton("save");
    setLeadTypeOfWorkInputs({ setLeadTypeOfWorkInputs: "" });
    setIsDialogOpen(true);
  };

  const handleChangeForleadTypeOfWork = (e) => {
    setLeadTypeOfWorkInputs({
      [e.target.name]: e.target.value,
    });
  };

  const handleSaveleadTypeOfWork = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem("token");
    if (!token) {
      triggerToast("error", "Authorization token is missing", "error");
      // toast.error("Authorization token is missing");
      return;
    }

    try {
      const response = await axios.post(
        "public/api/type-of-works",
        leadTypeOfWorkInputs,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setIsDialogOpen(false);
      setErrors();
      triggerToast(
        "success",
        "Type Of Work type added successfully",
        "success"
      );
      // toast.success("leadTypeOfWork type added successfully");
      fetchLeadTypeOfWork();
    } catch (error) {
      triggerToast("error", "Failed to add Type Of Work type", "error");
      // console.error("Error adding leadTypeOfWork type:", error);
    }
  };

  const handleEditleadTypeOfWork = async (id_crypt) => {
    setIsDialogOpen(true);
    setEditLeadDiscussionStationId(id_crypt);

    const token = localStorage.getItem("token");
    if (!token) {
      triggerToast("error", "Authorization token is missing", "error");
      // toast.error("Authorization token is missing");
      return;
    }

    try {
      const response = await axios.get(`public/api/type-of-works/${id_crypt}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      

      const leadTypeOfWorkData = response.data;

      // Correctly setting the state
      setLeadTypeOfWorkInputs({ name: leadTypeOfWorkData.name });

      setEditleadTypeOfWork(id_crypt);
      setLeadTypeOfWorkButton("update");
      setIsDialogOpen(true);
    } catch (error) {
      triggerToast("error", "Failed to fetch lead source for editing", "error");
      // console.error("Error fetching leadTypeOfWork:", error);
      // toast.error("Failed to fetch lead source for editing");
    }
  };

  const handleUpdateleadTypeOfWork = async (e) => {
    e.preventDefault();

    const token = localStorage.getItem("token");
    setLeadTypeOfWorkButton("update");

    try {
      const response = await axios.put(
        `public/api/type-of-works/${editLeadDiscussionStationId}`,
        leadTypeOfWorkInputs,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data) {
        setIsDialogOpen(false);
        triggerToast(
          "success",
          "Type Of Work type updated successfully",
          "success"
        );
        // toast.success("leadTypeOfWork type updated successfully");
        await fetchLeadTypeOfWork();
      } else {
        triggerToast("error", "Failed to update Type Of Work type", "error");
        // toast.error("Failed to update leadTypeOfWork type");
      }
    } catch (error) {
      triggerToast("error", "Failed to update Type Of Work type", "error");
      // console.error(
      //   "Error updating leadTypeOfWork type:",
      //   error.response ? error.response.data : error
      // );
      // toast.error("Failed to update leadTypeOfWork type");
    }
  };

  const handlePageChange = async (page) => {
    if (page !== "..." && !isNaN(page)) {
      const newPage = Number(page);
      setCurrentPage(newPage);
      await fetchLeadTypeOfWork(newPage);
    }
  };

  return (
    <>
      <HeaderWithButton
        title="Type Of Work"
        description="Type of work for leads"
        buttonText="Type Of Work"
        onButtonClick={handleAddleadTypeOfWork}
        // showButton={leadTypeOfWorkPermission}
      />

      <div className="grid grid-cols-1 gap-4 items-start sm:items-center">
        <div className="mt-6 overflow-x-auto rounded-lg shadow">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="py-3 px-5 border-b text-center  text-sm sm:text-base font-normal">
                  S No
                </th>
                <th className="py-3 px-5 border-b text-center text-sm sm:text-base font-normal">
                  Type Name
                </th>
                {/* <th className="py-3 px-5 border-b text-center  text-sm sm:text-base font-normal">
                  Actions
                </th> */}
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200 ">
              {paginationLeadTypeOfWorkData?.data?.length > 0 ? (
                paginationLeadTypeOfWorkData.data.map(
                  (leadTypeOfWork, index) => (
                    <tr key={index}>
                      <td className="px-6 py-4 whitespace-nowrap text-center text-sm font-medium">
                        {paginationLeadTypeOfWorkData.from + index}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-center text-sm text-gray-500">
                        {leadTypeOfWork.name}
                      </td>
                      {/* <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium flex justify-center">
                        <DeleteConfirmation
                          id_crypt={leadTypeOfWork.id_crypt}
                          apiType={"typeOfWork"}
                          fetchClientData={fetchLeadTypeOfWork}
                        />
                      </td> */}
                    </tr>
                  )
                )
              ) : (
                <tr>
                  <td
                    colSpan="3"
                    className="px-6 py-4 text-center text-sm text-gray-500"
                  >
                    No data available.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {isDialogOpen && (
          <Dialog
            open={isDialogOpen}
            onClose={() => setIsDialogOpen(false)}
            className="relative z-10"
          >
            <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-50 backdrop-blur-sm transition-opacity" />
            <div className="fixed inset-0 z-10 overflow-y-auto">
              <div className="flex min-h-full items-center justify-center p-4 text-center sm:p-0">
                <Dialog.Panel className="my-auto relative bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all w-full sm:w-full md:max-w-screen-sm lg:max-w-screen-xl h-full sm:h-auto max-h-[90vh] overflow-y-auto">
                  <div
                    className="flex justify-between items-center mb-4 p-4"
                    style={{ backgroundColor: "#6366f1" }}
                  >
                    <h1 className=" text-white mx-auto sm:px-6 sm:mx-0 md:px-8 sm:text-lg font-medium mb-2 uppercase z-100">
                      Type Of Work
                    </h1>
                    <button
                      type="button"
                      onClick={() => setIsDialogOpen(false)}
                    >
                      <XMarkIcon
                        className="h-6 w-6 sm:h-8 sm:w-8 text-white cursor-pointer"
                        aria-hidden="true"
                      />
                    </button>
                  </div>
                  <div className="w-full max-w-7xl mx-auto p-6 bg-gray-50">
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                      <div className="sm:col-span-2">
                        <form>
                          <div className="overflow-hidden sm:rounded-md">
                            <div className="space-y-4">
                              <div>
                                <label
                                  htmlFor="leadTypeOfWork"
                                  className="block text-sm font-medium leading-6 text-gray-900"
                                >
                                  Name
                                </label>
                                <div className="mt-2">
                                  <input
                                    name="name"
                                    type="text"
                                    value={leadTypeOfWorkInputs.name}
                                    onChange={handleChangeForleadTypeOfWork}
                                    autoComplete="mode"
                                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                  />
                                </div>
                                {errors && (
                                  <p className="mt-1 text-sm text-red-600">
                                    {errors}
                                  </p>
                                )}
                              </div>

                              <div className="flex  space-x-2">
                                {leadTypeOfWorkButton === "save" ? (
                                  <button
                                    onClick={handleSaveleadTypeOfWork}
                                    className="inline-flex justify-center py-2 px-4 w-auto border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                  >
                                    Add
                                  </button>
                                ) : (
                                  <button
                                    onClick={handleUpdateleadTypeOfWork}
                                    className="inline-flex justify-center py-2 px-4 w-auto border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                  >
                                    Update
                                  </button>
                                )}
                                <button
                                  type="button"
                                  onClick={() => setIsDialogOpen(false)}
                                  className="inline-flex justify-center py-2 px-4 w-auto border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
                                >
                                  Cancel
                                </button>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </Dialog.Panel>
              </div>
            </div>
          </Dialog>
        )}
      </div>

      {paginationLeadTypeOfWorkData && (
        <Pagination
          links={paginationLeadTypeOfWorkData.links}
          currentPage={paginationLeadTypeOfWorkData.current_page}
          totalResults={paginationLeadTypeOfWorkData.total}
          from={paginationLeadTypeOfWorkData.from}
          to={paginationLeadTypeOfWorkData.to}
          lastPage={paginationLeadTypeOfWorkData.last_page}
          onPageChange={handlePageChange}
        />
      )}
    </>
  );
}

export default TypeOfWorkList;
